import React from 'react'
import { Brush, Sparkles } from 'lucide-react'
import ToolButton from './ToolButton'

const ToolSelector = ({ onToolSelect, featureFlags }) => {
  return (
    <div className="space-y-4">
      {/* <div className="grid grid-cols-4 gap-2">
        <ToolButton icon={Brush} label="Brush" disabled />
        <ToolButton icon={Sliders} label="Adjust" disabled />
        <ToolButton icon={Image} label="Crop" disabled />
        <ToolButton icon={SunMedium} label="Effects" disabled />
      </div> */}
      
      <button 
        className={`w-full p-4 rounded-lg text-left relative
          ${featureFlags.generativeInpainting 
            ? 'bg-gray-700 hover:bg-gray-600 transition-colors'
            : 'bg-gray-700/50 cursor-not-allowed'}`}
        onClick={() => featureFlags.generativeInpainting && onToolSelect('inpainting')}
      >
        {!featureFlags.generativeInpainting && (
          <div className="absolute top-4 left-4">
            <div className="flex items-center gap-1.5 bg-gray-800/80 backdrop-blur-sm text-[10px] py-0.5 px-1.5 rounded-full tracking-wide font-medium text-gray-300">
              <Sparkles className="w-3 h-3" />
              <span>COMING SOON</span>
            </div>
          </div>
        )}
        <div className={`flex items-center gap-3 ${!featureFlags.generativeInpainting && 'opacity-50 mt-6'}`}>
          <div className="p-2 bg-gray-600 rounded-md">
            <Brush className="w-5 h-5" />
          </div>
          <div>
            <div className="font-medium">Generative Inpainting</div>
            <div className="text-sm text-gray-400">
              Add or modify photo with a mask and a modified prompt
            </div>
          </div>
        </div>
      </button>
    </div>
  )
}

export default ToolSelector 